import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { UIButtonModule } from '@homepower-co/shared-ui-angular';
import { AuthloginService } from '../../core/auth';

@Component({
  selector: 'app-close-section-button',
  standalone: true,
  imports: [RouterModule, MatIconModule, MatButtonModule, UIButtonModule],
  templateUrl: './close-section-button.component.html',
  styleUrls: ['./close-section-button.component.scss'],
})
export class CloseSectionButtonComponent {
  private authService = inject(AuthloginService);

  logout() {
    this.authService.logout();
  }
}
